import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography
} from "@material-ui/core";
import React from "react";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.common.white,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    header: {
      fontWeight: 700,
      marginTop: 24,
    },
    subtitle: {
      width: "40%",
      textAlign: "center",
      marginTop: 24,
      [theme.breakpoints.down("sm")]: {
        width: "90%",
      },
    },
  })
);

const Heading = () => {
  const classes = useStyles();
  let { league } = useParams<any>();

  return (
    <Box className={classes.root}>
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Typography variant="h4" className={classes.header} align="center">
          {league} DFS Player Compare
        </Typography>
      </Box>
      <Typography
        variant="subtitle1"
        align="center"
        className={classes.subtitle}
      >
        Search for player names to easily compare Stokastic metrics and get
        great support for your DFS lineups tonight. 1v1 and 2v2 comparisons are
        currently supported using DraftKings Main Slate data.
      </Typography>
    </Box>
  );
};

export default Heading;
